module.exports = __webpack_public_path__ + "img/cszl-4.d61e3c8c.png";